import * as E from "../../either";
import { fromValidate } from "../validated";
import { validationException } from "../validation-exception";
export const string = fromValidate((x) => typeof x === "string"
    ? E.right(x)
    : E.left(validationException(`Expected value to be a string, but was ${typeof x}.`)));

